import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';

// Style
import styleFn from '../../../../cross.env';

import { DateRangePicker } from 'react-dates';

//Move to incoming Prop

class DateRange extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    numberOfMonths: PropTypes.number.isRequired,
    formatMessage: PropTypes.func,
    personalized: PropTypes.shape({
      startDate: PropTypes.string,
      endDate: PropTypes.string,
    }),
  };

  constructor(props) {
    super(props);
    this.state = {
      focusedInput: null,
      startDate: null,
      endDate: null,
    };
    this.onDatesChange = this.onDatesChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
  }

  componentDidMount() {
    const { personalized } = this.props;
    if (personalized != undefined) {
      if (personalized.startDate && personalized.endDate) {
        this.setState({
          startDate: moment(personalized.startDate),
          endDate: moment(personalized.endDate),
        });
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { personalized, clearing, clearClear } = this.props;
    if (personalized != undefined) {
      if (
        personalized.startDate &&
        personalized.endDate &&
        personalized.startDate !== prevProps.personalized.startDate
      ) {
        this.setState({
          startDate: moment(personalized.startDate),
          endDate: moment(personalized.endDate),
        });
      }
    }
    if (clearing) {
      this.setState({
        startDate: null,
        endDate: null,
      });
      clearClear();
    }
  }

  onDatesChange({ startDate, endDate }) {
    const { onChange } = this.props;
    this.setState({ startDate, endDate });
    if (startDate != null && endDate != null) {
      onChange({
        startDate: startDate.format('MM/DD/YYYY'),
        endDate: endDate.format('MM/DD/YYYY'),
      });
    }
  }

  onFocusChange(focusedInput) {
    this.setState({ focusedInput });
  }

  render() {
    const { focusedInput, startDate, endDate } = this.state;
    const { numberOfMonths } = this.props;
    return (
      <div>
        <DateRangePicker
          {...this.props}
          onDatesChange={this.onDatesChange}
          onFocusChange={this.onFocusChange}
          focusedInput={focusedInput}
          startDate={startDate}
          endDate={endDate}
          numberOfMonths={2}
          minimumNights={0}
          startDatePlaceholderText="Pickup"
          endDatePlaceholderText="Dropoff"
          hideKeyboardShortcutsPanel
        />
      </div>
    );
  }
}

export default styleFn(DateRange);



// WEBPACK FOOTER //
// ./src/components_new/common/FormComponents/DateRange/SearchDateRange.js